export default __webpack_public_path__ + "static/media/pricingPage.617e85ab.jpg";